(() => {
  const parseStoreDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return new Date();
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12);
  };

  const addBusinessDays = (source, count) => {
    const date = new Date(source);
    let remaining = count;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }
    return date;
  };

  const formatRange = (start, end) => {
    const sameYear = start.getFullYear() === end.getFullYear();
    const short = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    const long = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return `${sameYear ? short.format(start) : long.format(start)}–${long.format(end)}`;
  };

  const update = (element) => {
    const today = parseStoreDate(element.dataset.rspToday);
    const standard = element.querySelector('[data-rsp-standard-dates]');
    const priority = element.querySelector('[data-rsp-priority-dates]');
    if (standard) standard.textContent = formatRange(addBusinessDays(today, 8), addBusinessDays(today, 11));
    if (priority) priority.textContent = formatRange(addBusinessDays(today, 6), addBusinessDays(today, 9));
  };

  const init = () => document.querySelectorAll('[data-rsp-delivery-estimate]').forEach(update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
